import React, { useEffect, useState } from 'react';
import './SurveyReport.less';
import { getDocPreviewToken } from '../api';
import { useLocation } from 'react-router-dom';
import config from '../../../config';

let docViewer: any = null;

// 查看报告
const SurveyReport: React.FC = () => {
    const location = useLocation();

    const [imageUrl, setImageUrl] = useState('');

    const viewReport = async () => {
        const info = location.state.info;
        let ext = info.reportFile ? info.reportFile.substr(info.reportFile.length - 3, 3).toLowerCase() : '';
        document.title = info.reportFileName ? info.reportFileName.slice(0, -4) : '';
        if (ext !== 'pdf') {
            let url = `${config.OSS_URL_PREFIX}/${info.reportFile}`;
            setImageUrl(url);
            return;
        }
        let srcUri = `oss://battleship-cloud/${info.reportFile}`;
        const res: any = await getDocPreviewToken({ srcUri });
        if (res.status_code === 200 && res.data) {
            const data = JSON.parse(res.data);
            if (data) {
                let accessToken = '';
                let previewURL = '';
                if (data.body && data.body.accessToken && data.body.previewURL) {
                    accessToken = data.body.accessToken;
                    previewURL = data.body.previewURL;
                }

                if (!!accessToken && !!previewURL) {
                    docViewer = (window as any).aliyun.config({
                        mount: document.querySelector('#doc-viewer'),
                        url: previewURL,
                    });

                    docViewer.setToken({ token: accessToken });

                    viewDoc(ext);
                }
            }
        }
    };

    const viewDoc = async (ext: string) => {
        await docViewer.ready();

        let pageCount = 0;
        // PPT
        if (ext === 'ppt') {
            pageCount = await docViewer.PDFApplication().ActivePDF.PagesCount;
        }
    };

    useEffect(() => {
        viewReport();
    }, []);

    return (
        <div className="doc-report">
            {imageUrl ? (
                <div className="doc-img">
                    {' '}
                    <img src={imageUrl} alt="" />{' '}
                </div>
            ) : (
                <div id="doc-viewer"></div>
            )}
        </div>
    );
};

export default SurveyReport;
